import React, { createContext, useContext, useMemo, useState } from "react";

type ISidebarMenuContext = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SidebarMenuContext = createContext<any>({
  isSidebarOpen: null,
});

interface SidebarMenuProviderProps {
  children: React.ReactNode;
}

const SidebarMenuProvider: React.FC<SidebarMenuProviderProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      isSidebarOpen,
      setIsSidebarOpen,
    }),
    [isSidebarOpen],
  );

  return (
    <SidebarMenuContext.Provider value={value}>
      {children}
    </SidebarMenuContext.Provider>
  );
};

const useSidebarMenuContext = (): ISidebarMenuContext =>
  useContext(SidebarMenuContext);

export { SidebarMenuProvider, useSidebarMenuContext, type ISidebarMenuContext };
